var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSkipRight = function SvgSkipRight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "S\\xEDmbolo_17_10",
    "data-name": "S\\xEDmbolo 17 \\u2013 10",
    transform: "translate(-4 -3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_534",
    "data-name": "Ret\\xE2ngulo 534",
    width: 35,
    height: 35,
    transform: "translate(4 3)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2182",
    "data-name": "Caminho 2182",
    d: "M10,1.9,8.1,0,0,8.1l8.1,8.1,1.9-1.9L3.819,8.1Z",
    transform: "translate(26.027 28.618) rotate(180)",
    fill: "#4b4b4b"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSkipRight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/skip-right.021a79e4.svg";
export { ForwardRef as ReactComponent };